import { getUsersRoles } from '../../../api/users';
import { GET_ALL_USER_ROLES, UPDATE_USER_ROLES_PENDING, BAD_LOAD } from '../constants';
export default {
  async updatePending({ commit, state }, value) {
    commit(UPDATE_USER_ROLES_PENDING, value);
  },
  async getAll({ commit }) {
    try {
      commit(UPDATE_USER_ROLES_PENDING, true);
      const data = await getUsersRoles();
      commit(GET_ALL_USER_ROLES, data);
    } catch (e) {
      commit(BAD_LOAD, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_USER_ROLES_PENDING, false);
    }
  }
};
